import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Typography from '../Typography';

const Tabs = ({ id, tabs, activeTabId, onChange, className, ariaLabel }) => {
  const handleClick = (tabId) => {
    if (tabId === activeTabId) {
      return;
    }
    if (onChange) {
      onChange(tabId);
    }
  };

  return (
    <div
      id={id}
      data-testid={id}
      role="tablist"
      aria-label={ariaLabel}
      className={clsx('flex flex-row gap-[15px]', className)}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTabId;
        return (
          <button
            key={tab.id}
            id={id ? `${id}-${tab.id}` : tab.id}
            data-testid={id ? `${id}-${tab.id}` : tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-disabled={!isActive}
            onClick={() => handleClick(tab.id)}
            className={clsx(
              'w-[35%] py-[7px] rounded-tl-[8px] rounded-tr-[8px]',
              isActive
                ? 'bg-legacy-primary border border-legacy-primary'
                : 'bg-legacy-bgLighter border border-legacy-borderLight',
            )}
          >
            <Typography
              type="caption1"
              className={`${isActive ? '!text-white' : 'text-legacy-textDark'}`}
            >
              {tab.label}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};

Tabs.propTypes = {
  id: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
  activeTabId: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default Tabs;
